import React, { useCallback, useContext } from 'react';
import { useClassNames } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { PlayStateIcon } from './PlayStateIcon/PlayStateIcon';
import { PlaybackSettings } from './PlaybackSettings/PlaybackSettings';
import { ProgressContainer } from './ProgressContainer/ProgressContainer';
import ChannelPlaylistItem from '../../../models/ChannelPlaylistItem';
import { ProgramsList } from './ProgramsList/ProgramsList';
import { NextEpisodeButton } from '../NextEpisodeButton';
import { PlaybackInformationContext } from '../../../contexts/PlaybackInformationContext';
import { PlaybackContext } from '../../../contexts/PlaybackContext';
import { SkipIntroButton } from '../SkipIntroButton';

const onDoubleClick = (event) => {
	event.stopPropagation();
};

export const PlaybackInformationContent: React.FC = () => {
	const { playbackInformationVisible, onCloseRequested } = useContext(PlaybackInformationContext);
	const { playlistItem } = useContext(PlaybackContext);

	const onCloseClicked = useCallback(
		(event) => {
			event.preventDefault();
			event.stopPropagation();

			onCloseRequested();
		},
		[onCloseRequested]
	);

	const classNames = useClassNames('playback-information-content', {
		visible: playbackInformationVisible,
		hidden: !playbackInformationVisible,
	});

	if (!playlistItem) return null;

	return (
		<div className={'playback-information'}>
			<div className={classNames}>
				<div className={'playback-information-background'} />
				<div className={'playback-information-cancel'}>
					<div role={'presentation'} className={'playback-information-cancel-button'} onDoubleClick={onDoubleClick} onClick={onCloseClicked} onTouchStart={onCloseClicked} />
				</div>
				<div className={'playback-information-bar-wrapper'}>
					<div className={'playback-information-bar'} onDoubleClick={onDoubleClick}>
						<PlayStateIcon />
						<div className={'playback-information-wrapper'}>
							<div className={'playback-information-title-settings-wrapper'}>
								<div className={'playback-information-title'}>{playlistItem.getContentTitle()}</div>
								<PlaybackSettings />
							</div>
							<ProgressContainer />
						</div>
					</div>
					{playlistItem instanceof ChannelPlaylistItem && <ProgramsList />}
				</div>
			</div>
			<SkipIntroButton />
			<NextEpisodeButton />
		</div>
	);
};
